import request from '@/utils/request'

// v80c1010List
export function v80c1010List(param) {
    let data = param
    return request({
      url: `/v80/v80c1010/v80c1010List`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }